import { Clock, MapPin, Phone } from "lucide-react";
import { BUSINESS_PHONE, BUSINESS_PHONE_DISPLAY } from "./constants";

export default function HoursArea() {
  return (
    <section id="hours-area" data-testid="hours-area-section" className="py-24 px-6 max-w-6xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-8 items-stretch">
        <div className="bg-[#101726] border border-white/10 rounded-2xl p-8 sm:p-10 flex flex-col justify-between">
          <div>
            <p className="font-mono-lbl text-xs uppercase tracking-widest text-[#00e5ff] flex items-center gap-2">
              <Clock className="w-4 h-4" /> Hours &amp; Dispatch Window
            </p>
            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tight mt-3">
              When We Roll
            </h2>
            <div className="mt-8 space-y-5">
              <div
                data-testid="hours-weekday"
                className="flex items-center justify-between border-b border-white/10 pb-4"
              >
                <span className="text-slate-300 text-sm font-semibold">Monday &ndash; Friday</span>
                <span className="font-mono-lbl text-sm text-white">5:30 PM &ndash; 11:00 PM</span>
              </div>
              <div
                data-testid="hours-weekend"
                className="flex items-center justify-between border-b border-white/10 pb-4"
              >
                <span className="text-slate-300 text-sm font-semibold">Saturday &ndash; Sunday</span>
                <span className="font-mono-lbl text-sm text-[#00e5ff]">Open Availability</span>
              </div>
              <p className="text-slate-400 text-xs leading-relaxed">
                Roadside emergencies jump the queue. Stranded right now? Skip the form and call
                dispatch directly.
              </p>
            </div>
          </div>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href={`tel:${BUSINESS_PHONE}`}
              data-testid="hours-call-link"
              className="flex-1 inline-flex items-center justify-center gap-2 bg-[#ff4b2b] hover:bg-[#ff3411] text-white px-6 py-3.5 rounded-lg font-bold text-sm uppercase tracking-wide transition-colors shadow-lg shadow-[#ff4b2b]/30"
            >
              <Phone className="w-4 h-4" />
              Call {BUSINESS_PHONE_DISPLAY}
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Revive+%26+Drive+Auto+LLC+Dayton+OH"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="directions-link"
              className="flex-1 inline-flex items-center justify-center gap-2 border border-white/20 hover:border-white/50 text-white px-6 py-3.5 rounded-lg font-bold text-sm uppercase tracking-wide transition-colors"
            >
              <MapPin className="w-4 h-4 text-[#00e5ff]" />
              Get Directions
            </a>
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden border border-white/15 shadow-2xl min-h-[360px]">
          <iframe
            title="Revive & Drive Auto LLC service area map — Dayton and Cincinnati, Ohio"
            data-testid="service-area-map"
            src="https://www.openstreetmap.org/export/embed.html?bbox=-84.75%2C38.95%2C-83.85%2C39.95&layer=mapnik"
            className="absolute inset-0 w-full h-full"
            style={{ filter: "invert(0.92) hue-rotate(180deg) saturate(0.6) brightness(0.9)" }}
            loading="lazy"
          />
          <div className="absolute bottom-4 left-4 z-10 flex items-center gap-2 px-3 py-2 rounded-lg bg-[#080d15]/90 border border-white/15 backdrop-blur">
            <MapPin className="w-4 h-4 text-[#ff4b2b]" />
            <span className="font-mono-lbl text-xs text-white uppercase tracking-wider">
              Dayton &bull; Cincinnati &amp; Surrounding Areas
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
